/**
 This file contains all the js required for thank-you form validation and submission.
*/

import validateForm from './validation/validateForm';
import {formFieldChecked, formFieldValue} from './selectors/formFieldValue';
import forEachElement from './selectors/forEachElement';
import addClass from './selectors/addClass';
import removeClass from './selectors/removeClass';
import submitForm from './form/submitForm';
import ajaxUrl from './form/ajaxUrl';
import isProject from './selectors/isProject';

/**
 * Sets up the form validation and Ajax form submit
 *
 * @param {string} [thankYouFormWrapperSelector = '.js-leadform']
 * Outermost wrapper class of leadform
 */
export const setUpFormThankYou = function(thankYouFormWrapperSelector = '.js-leadform') {
  // Initialize form validation on the thank you form.
  // It has the name attribute "registration"
  forEachElement(`${thankYouFormWrapperSelector} .form--tou`, form => {
    const nextButtons = form.querySelectorAll('.js-lead-constructor__next');
    form.addEventListener('submit', function(event) {
      event.preventDefault();
      if(validateForm(form) && !isProject('vt_virtual_learning_hagrid')) {
        thankYouSubmitHandler(form);
      }
    });

    // cancel default fallback actions
    forEachElement(nextButtons, el => el.onclick = null);
  });
};

/**
 * Callback for handling the actual submit when the form is validated. Submits
 * the form via Ajax, and redirects user to appropriate thank you page.
 *
 * @param {element} form Form currently being validated
 */
const thankYouSubmitHandler = function(form) {
  const formDataAsJSON = getFormData(form);
  const correlationId = formFieldValue(form, 'correlationId');
  postForm(formDataAsJSON, correlationId, form);
};

// Get data from form
const getFormData = function (form) {
  const data = [{ 'op': 'replace',
                  'path': 'contact_details/dialer_consent_accepted',
                  'value': formFieldChecked(form, 'dialer_consent_accepted') },
                { 'op': 'replace',
                  'path': 'callback_time',
                  'value': '' },
                { 'op': 'replace',
                  'path': 'contact_details/phone',
                  'value': formFieldValue(form, 'hidden_phone') },
                {'op': 'replace',
                  'path': 'lead_form.heard_about_us',
                  'value': formFieldValue(form, 'heard_about_us', '') }];
  return JSON.stringify(data);
};

// Post form to vt-contact
const postForm = function (data, correlationId, form) {
  submitForm(
    ajaxUrl(form, correlationId),
    data,
    'PATCH'
  ).then(() => {
    addClass('.lead-constructor__panel--thank-you-panel', 'active');
    addClass('.lead-constructor__panel--thank-you-form', 'complete');
    removeClass('.lead-constructor__panel--thank-you-form', 'active');
  }).catch(error => {
    forEachElement('.contact-form__info', el =>
      el.innerHTML = 'Your request was not sent.<br>Please try again.'
    );
    if(window.newrelic) {
      window.newrelic.noticeError(error, {
        api_endpoint: ajaxUrl(form)
      });
    }
  });
};



// WEBPACK FOOTER //
// ./client/app/scripts/principles/leadform-thank-you.js